// 菁亿项目
import request from '@/utils/request'

// 新版-查询一览
export function selectProjectCenterTwov1(data) {
  return request({
    url: '/projectCenter/selectProjectCenterTwo',
    method: 'post',
    data
  })
}

// 新版-查询一览-数量
export function number(data) {
  return request({
    url: '/projectCenter/selectSaasProjectCenterTwo/number',
    method: 'post',
    data
  })
}

// 查询沟通列表
export function selectIntermediate(data) {
  return request({
    url: '/projectCenter/selectIntermediate',
    method: 'post',
    data
  })
}

// 查询列表（菁亿用户分配）
export function list(data) {
  return request({
    url: '/sassa_user/v1/list',
    method: 'post',
    data
  })
}

// 指定发布用户（菁亿用户分配）
export function publishUser(data) {
  return request({
    url: '/projectCenter/publishUser',
    method: 'post',
    data
  })
}

// 指定发布用户（菁亿用户分配）
export function publishAll(data) {
  return request({
    url: '/projectCenter/publishAll',
    method: 'post',
    data
  })
}

// 新版-新增(项目类型0->内；1->外；2 -> 菁亿项目)
export function saveProject(data) {
  return request({
    url: '/projectCenter/saveProject',
    method: 'post',
    data
  })
}

// 新版-修改
export function updateProject(data) {
  return request({
    url: '/projectCenter/updateProject',
    method: 'post',
    data
  })
}

// 更改项目的进度
export function updateProjectSchedule(data) {
  return request({
    url: '/projectCenter/updateProjectSchedule',
    method: 'post',
    data
  })
}


// 项目JD下载
// export function reportDownLoad(data) {
//   return request({
//     url: '/sassa_project/v1/reportDownLoad',
//     method: 'get',
//     params: data
//   })
// }

// 查询单个
export function selectBYId(data) {
  return request({
    url: '/projectCenter/selectBYId',
    method: 'get',
    params: data
  })
}

// 删除
export function deleteProject(data) {
  return request({
    url: '/projectCenter/delete',
    method: 'post',
    data
  })
}

// 修改级别
export function updatePriority(data) {
  return request({
    url: '/projectCenter/updatePriority',
    method: 'post',
    data
  })
}

// 修改项目状态
export function updateStatus(data) {
  return request({
    url: '/sassa_project/v1/updateStatus',
    method: 'get',
    params: data
  })
}

// 根据查询参数查看项目人才进度相应的数量
export function progressCntNew(data) {
  return request({
    url: '/projectCenter/progressCntNew',
    method: 'post',
    data
  })
}

// 项目JD下载
export function reportDownLoad(data) {
  return request({
    url: '/projectCenter/reportDownLoad',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

// 查询审核人选一览
export function personList(data) {
  return request({
    url: '/sassa_review/v1/personList',
    method: 'post',
    data
  })
}

// 添加沟通列表同意
export function agree(data) {
  return request({
    url: '/sassa_review/v1/person/agree',
    method: 'post',
    data
  })
}

// 添加沟通列表拒绝
export function reject(data) {
  return request({
    url: '/sassa_review/v1/person/reject',
    method: 'post',
    data
  })
}

// 查询拒绝理由 024 （状态 021）
export function rejectionType(data) {
  return request({
    url: '/sassa_review/v1/rejectionType',
    method: 'get',
    params: data
  })
}

// 查询人选的审核数量
export function personReview(data) {
  return request({
    url: '/sassa_review/v1/personReview',
    method: 'post',
    data
  })
}
